import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { useAuth } from "~/providers/store/auth";
import { client } from "~/api/client";

export const schoolsKeys = createQueryKeys("school", {
  detail: (schoolId: string) => ({ queryKey: [schoolId] }),
  list: (partnerId: string) => ({ queryKey: [partnerId] })
});

export const schoolQuery = (schoolId: string | null | undefined) =>
  queryOptions({
    ...schoolsKeys.detail(schoolId || "unknown"),
    queryFn: async () => {
      if (!schoolId) throw new Error("No school id provided");

      const res = await client.v1.pos.schools.getById({
        params: { schoolId }
      });

      if (res.status === 200) {
        return res.body;
      }

      throw res;
    },
    enabled: Boolean(schoolId)
  });

type SchoolQueryData = Awaited<
  ReturnType<NonNullable<ReturnType<typeof schoolQuery>["queryFn"]>>
>;

export function useCurrentSchool<TSelected = SchoolQueryData>(
  select?: (data: SchoolQueryData) => TSelected
) {
  const { schoolId } = useAuth();

  return useQuery({ ...schoolQuery(schoolId), select });
}
